export default "__VITE_ASSET__603f778c__"